module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-zh-TW.4f91a438.jpg";